// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3sFME","col":"styles_col__17nm-","fulfillmentStatus":"styles_fulfillmentStatus__2C2p5","emailCol":"styles_emailCol__2MowX"};